import { Link } from 'react-router-dom';

import EmailLink from '@/components/ui/EmailLink.tsx';
import { ROUTES } from '@/config/routes';
import { useSaasStore } from '@/stores/saas-store.ts';

export default function CguSections2() {
  const playerPlusEnabled = useSaasStore(s => s.playerPlusEnabled);
  return (
    <>
      {/* 9. Responsabilités */}
      <div id='responsabilites' className='bg-white rounded-3xl shadow-sm border border-slate-100 p-8'>
        <h2 className='text-xl font-extrabold text-slate-900 mb-4'>9. Responsabilités</h2>
        <div className='text-sm text-slate-600 leading-relaxed space-y-3'>
          <p>
            <strong className='text-slate-900'>Obligations de l'Éditeur :</strong> MADSAAS SAS s'engage à mettre en
            œuvre tous les moyens raisonnables pour assurer la disponibilité et la sécurité de la Plateforme (obligation
            de moyens). L'Éditeur ne saurait être tenu responsable des interruptions liées à des opérations de
            maintenance, des pannes techniques, des cas de force majeure ou de la défaillance de prestataires tiers
            (hébergeur, prestataire de paiement, services d'infrastructure et d'orchestration).
          </p>
          <p>
            <strong className='text-slate-900'>Responsabilité de l'Utilisateur :</strong> L'Utilisateur est seul
            responsable de l'utilisation qu'il fait de la Plateforme, des contenus qu'il y publie (affiche, description,
            résultats) et du respect de la réglementation applicable. Il s'engage à n'utiliser la Plateforme qu'à des
            fins licites.
          </p>
          <p>
            <strong className='text-slate-900'>Responsabilité spécifique des Organisateurs :</strong> Les Organisateurs
            sont seuls responsables de l'organisation matérielle et juridique de leurs Concours, du respect des
            réglementations sportives (FFPJP, FIPJP ou équivalents), de la sécurité des participants, des assurances
            nécessaires et de leurs obligations fiscales liées aux droits d'inscription perçus. BoulesConnect agit
            exclusivement en qualité d'intermédiaire technique et d'interface de mise en relation. MADSAAS SAS ne
            saurait être tenue responsable des litiges entre Organisateurs et Joueurs relatifs aux conditions
            d'organisation d'un Concours.
          </p>
          <p>
            MADSAAS SAS n'assure pas et ne garantit pas l'absence de litiges, de rétrofacturations, de fraudes, ni
            l'absence de mesures de gestion des risques décidées par Stripe (réserves, blocages, retards de versement,
            limitations, suspensions).
          </p>
          <p>
            <strong className='text-slate-900'>Limitation de responsabilité :</strong> La responsabilité de l'Éditeur
            est expressément limitée au montant des sommes effectivement payées par l'Utilisateur à MADSAAS SAS au cours
            des 12 derniers mois précédant l'événement dommageable. Cette limitation ne s'applique pas en cas de faute
            lourde ou de dol de l'Éditeur.
          </p>
          <p>
            MADSAAS SAS n'est tenue à aucune obligation de résultat concernant l'acceptation des paiements, les délais
            de versement, ni l'absence de litiges, de fraude, de rétrofacturations, ou de mesures de gestion des risques
            décidées par Stripe.
          </p>
        </div>
      </div>

      {/* 10. Données personnelles */}
      <div id='donnees' className='bg-white rounded-3xl shadow-sm border border-slate-100 p-8'>
        <h2 className='text-xl font-extrabold text-slate-900 mb-4'>10. Données personnelles</h2>
        <div className='text-sm text-slate-600 leading-relaxed space-y-3'>
          <p>
            MADSAAS SAS collecte et traite des données personnelles en qualité de responsable de traitement, dans le
            cadre de la fourniture de ses services, conformément au Règlement Général sur la Protection des Données
            (RGPD — Règlement UE 2016/679) et à la loi Informatique et Libertés modifiée.
          </p>
          <p>
            Les données collectées incluent notamment les informations de profil, les données de connexion, les
            informations relatives aux inscriptions et paiements, ainsi que les données de géolocalisation (avec
            consentement). Certaines données (numéro de licence, prénom, nom) peuvent être visibles d'autres
            Utilisateurs dans le cadre du fonctionnement normal de la Plateforme (pages résultats, équipes).
          </p>
          <p>
            Pour l'intégralité des informations relatives au traitement de vos données personnelles, vos droits (accès,
            rectification, suppression, portabilité, opposition) et les coordonnées du délégué à la protection des
            données, veuillez consulter notre{' '}
            <Link to={ROUTES.POLITIQUE_RGPD} className='text-blue-600 hover:underline'>
              Politique de Confidentialité et RGPD
            </Link>
            .
          </p>
        </div>
      </div>

      {/* 11. Propriété intellectuelle */}
      <div id='propriete' className='bg-white rounded-3xl shadow-sm border border-slate-100 p-8'>
        <h2 className='text-xl font-extrabold text-slate-900 mb-4'>11. Propriété intellectuelle</h2>
        <div className='text-sm text-slate-600 leading-relaxed space-y-3'>
          <p>
            La Plateforme BoulesConnect, son architecture, son code source, ses interfaces, sa charte graphique, ses
            marques, logos et bases de données sont la propriété exclusive de MADSAAS SAS et sont protégés par les
            dispositions du Code de la propriété intellectuelle et les conventions internationales.
          </p>
          <p>
            Toute reproduction, représentation, extraction, modification ou exploitation non expressément autorisée, par
            quelque moyen que ce soit, est strictement interdite et constitue une contrefaçon susceptible d'engager la
            responsabilité civile et pénale de son auteur.
          </p>
          <p>
            L'Utilisateur concède à MADSAAS SAS une licence non exclusive, gratuite, mondiale et pour la durée de son
            compte, sur les contenus qu'il publie sur la Plateforme (affiche, description, résultats), aux seules fins
            du fonctionnement, de la promotion et de l'amélioration des services. Cette licence prend fin à la
            suppression du compte ou du contenu concerné.
          </p>
        </div>
      </div>

      {/* 12. Résiliation */}
      <div id='resiliation' className='bg-white rounded-3xl shadow-sm border border-slate-100 p-8'>
        <h2 className='text-xl font-extrabold text-slate-900 mb-4'>12. Résiliation</h2>
        <div className='text-sm text-slate-600 leading-relaxed space-y-3'>
          <p>
            <strong className='text-slate-900'>À l'initiative de l'Utilisateur :</strong> Tout Utilisateur peut résilier
            son compte à tout moment depuis son espace personnel ou en adressant une demande à{' '}
            <EmailLink user='support' domain='boulesconnect.fr' className='text-blue-600 hover:underline' />. Pour les
            abonnements payants (Joueur Plus, Club Pro), la résiliation prend effet à l'expiration de la période déjà
            facturée et payée. Aucun remboursement au prorata n'est effectué pour la période restante, sauf exercice du
            droit de rétractation dans les conditions de l'article 7.
          </p>
          <p>
            <strong className='text-slate-900'>Plan Commission Partenaire :</strong> Ce plan étant gratuit, il peut être
            résilié à tout moment sans préavis ni frais. La résiliation prend effet immédiatement.
          </p>
          <p>
            <strong className='text-slate-900'>À l'initiative de l'Éditeur :</strong> MADSAAS SAS se réserve le droit de
            suspendre ou résilier le compte d'un Utilisateur en cas de manquement grave ou répété aux présentes CGU/CGV.
            Sauf urgence (fraude, atteinte à la sécurité), une mise en demeure est adressée par email, l'Utilisateur
            disposant d'un délai de 15 jours pour régulariser sa situation. En cas de résiliation pour faute, aucun
            remboursement des sommes versées n'est dû.
          </p>
          <p>
            À l'issue de la résiliation, les données de l'Utilisateur sont conservées selon les durées définies dans la
            Politique de Confidentialité, puis supprimées ou anonymisées.
          </p>
        </div>
      </div>

      {/* 13. Modification des CGU */}
      <div id='modification' className='bg-white rounded-3xl shadow-sm border border-slate-100 p-8'>
        <h2 className='text-xl font-extrabold text-slate-900 mb-4'>13. Modification des CGU/CGV</h2>
        <div className='text-sm text-slate-600 leading-relaxed space-y-3'>
          <p>
            MADSAAS SAS se réserve le droit de modifier les présentes CGU/CGV à tout moment afin de les adapter à
            l'évolution de la Plateforme, de la réglementation ou des pratiques commerciales.
          </p>
          <p>
            Toute modification substantielle sera notifiée aux Utilisateurs par email et/ou par notification in-app au
            moins <strong className='text-slate-900'>30 jours</strong> avant son entrée en vigueur. La date de la
            dernière mise à jour figure en haut de ce document.
          </p>
          <p>
            <strong className='text-slate-900'>Pour les Utilisateurs consommateurs (B2C) :</strong> l'acceptation des
            nouvelles conditions est requise par un consentement explicite (case à cocher ou clic sur un bouton dédié).
            L'utilisation continue de la Plateforme sans acceptation explicite ne vaut pas acceptation des nouvelles
            conditions.
          </p>
          <p>
            <strong className='text-slate-900'>
              Pour les Utilisateurs professionnels (B2B — organisateurs, clubs) :
            </strong>{' '}
            l'utilisation continue de la Plateforme après l'entrée en vigueur des nouvelles conditions vaut acceptation
            de celles-ci.
          </p>
          <p>En cas de désaccord, l'Utilisateur peut résilier son compte dans les conditions de l'article 12.</p>
        </div>
      </div>

      {/* 14. Droit applicable */}
      <div id='droit' className='bg-white rounded-3xl shadow-sm border border-slate-100 p-8'>
        <h2 className='text-xl font-extrabold text-slate-900 mb-4'>14. Droit applicable et juridiction compétente</h2>
        <div className='text-sm text-slate-600 leading-relaxed space-y-3'>
          <p>
            Les présentes CGU/CGV sont soumises au droit français. En cas de litige relatif à leur interprétation ou à
            leur exécution, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire.
          </p>
          <p>
            <strong className='text-slate-900'>Pour les contrats B2B :</strong> tout litige non résolu amiablement sera
            soumis à la compétence du Tribunal de commerce de Gap pour les Organisateurs commerçants, ou du Tribunal
            judiciaire de Gap pour les associations et Organisateurs non commerçants.
          </p>
          {playerPlusEnabled && (
            <>
              <p>
                <strong className='text-slate-900'>Pour les contrats B2C (consommateurs) :</strong> conformément à
                l'article R.631-3 du Code de la consommation, le consommateur peut saisir la juridiction du lieu où il
                demeurait au moment de la conclusion du contrat ou du lieu où il demeurait au moment du fait
                dommageable.
              </p>
              <p>
                <strong className='text-slate-900'>Médiateur de la consommation :</strong> conformément aux articles
                L.616-1 et R.616-1 du Code de la consommation, MADSAAS SAS adhère au service de médiation suivant :
              </p>
              <div className='p-5 bg-slate-50 rounded-2xl border border-slate-200 space-y-1'>
                <p>
                  <strong className='text-slate-900'>SAS Médiation Solution</strong>
                </p>
                <p>222 chemin de la bergerie, 01800 Saint-Jean-de-Niost</p>
                <p>
                  Saisine en ligne :{' '}
                  <a
                    href='https://www.sasmediationsolution-conso.fr'
                    className='text-blue-600 hover:underline'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    sasmediationsolution-conso.fr
                  </a>
                </p>
                <p>
                  Email :{' '}
                  <a href='mailto:contact@sasmediationsolution-conso.fr' className='text-blue-600 hover:underline'>
                    contact@sasmediationsolution-conso.fr
                  </a>
                </p>
              </div>
              <p>
                Le consommateur peut également accéder à la plateforme européenne de règlement en ligne des litiges
                (RLL) à l'adresse{' '}
                <a
                  href='https://ec.europa.eu/consumers/odr'
                  className='text-blue-600 hover:underline'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  ec.europa.eu/consumers/odr
                </a>
                .
              </p>
            </>
          )}
          <p>
            En cas de litige relatif au traitement des données personnelles non résolu directement avec MADSAAS SAS,
            l'Utilisateur peut introduire une réclamation auprès de la{' '}
            <a
              href='https://www.cnil.fr/fr/plaintes'
              className='text-blue-600 hover:underline'
              target='_blank'
              rel='noopener noreferrer'
            >
              CNIL
            </a>
            .
          </p>
        </div>
      </div>

      {/* 15. Contact */}
      <div id='contact' className='bg-white rounded-3xl shadow-sm border border-slate-100 p-8'>
        <h2 className='text-xl font-extrabold text-slate-900 mb-4'>15. Contact</h2>
        <div className='text-sm text-slate-600 leading-relaxed space-y-3'>
          <p>Pour toute question relative aux présentes CGU/CGV ou à vos droits, vous pouvez contacter :</p>
          <div className='p-5 bg-slate-50 rounded-2xl border border-slate-200 space-y-1'>
            <p>
              <strong className='text-slate-900'>MADSAAS SAS</strong> — BoulesConnect
            </p>
            <p>05110 Lardier-et-Valença, France</p>
            <p>SIREN : 821 350 600</p>
            <p>
              Support utilisateur :{' '}
              <EmailLink user='support' domain='boulesconnect.fr' className='text-blue-600 hover:underline' />
            </p>
            <p>
              Questions privacy, juridiques, CGU :{' '}
              <EmailLink user='dpo' domain='boulesconnect.fr' className='text-blue-600 hover:underline' />
            </p>
            <p>
              Support via la plateforme :{' '}
              <Link to={ROUTES.SUPPORT} className='text-blue-600 hover:underline'>
                boulesconnect.fr/support
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
